var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u(
      [
        {
          key: "datetime",
          fn: function() {
            return [
              _c("QpeDatetime", {
                attrs: {
                  props_date: _vm.date,
                  props_time: _vm.time,
                  name: _vm.default_value,
                  allow_hour_list: _vm.allow_hour_list
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time
                }
              })
            ]
          },
          proxy: true
        },
        _vm.unit_column_list.length > 1
          ? {
              key: "description",
              fn: function() {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "switch-btn",
                      on: { click: _vm.switch_unit_column }
                    },
                    [_vm._v("\n                切換表格單位\n            ")]
                  )
                ]
              },
              proxy: true
            }
          : null,
        {
          key: "data_table",
          fn: function(slot_props) {
            return [
              _c("QpeDatatable", {
                staticClass: "datetime_merge_monitor",
                attrs: {
                  data: _vm.table_data,
                  headers: _vm.header,
                  name: _vm.default_value,
                  error_text: _vm.error_text,
                  props_date: _vm.date,
                  props_time: _vm.time,
                  search: slot_props.search,
                  should_show_raw_html_header: _vm.should_show_raw_html_header,
                  custom_header: true,
                  show_table_border: true,
                  show_download_pdf_btn: false,
                  show_download_png_btn: false
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "table_description",
                      fn: function() {
                        return [
                          _c("span", [
                            _vm._v("\n                        說明："),
                            _c("br"),
                            _vm._v(
                              "\n                        --: 無資料\n                    "
                            )
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }